import boxShipping from './boxShipping';
import checking from './checking';
import packing from './packing';
import palletShipping from './palletShipping';

export default [...checking, ...packing, ...palletShipping, ...boxShipping];
